export default "__VITE_ASSET__CegR27TA__"